export default "__VITE_ASSET__D_H2z0EG__"